import { styled } from '@mui/material/styles';
import { Box, Typography, TypographyProps } from '@mui/material';
import { primaryColor } from '../../utils/theme';

export const BreadcrumbContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 0), 
  color: theme.palette.custom.lightGrey,
  fontSize: '1rem',
}));

export const BreadcrumbItem = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: theme.palette.custom.lightGrey,
  fontWeight: 500,
  fontSize: '1rem',
  
  '&.MuiTypography-root:last-child': {
    color: theme.palette.text.secondary, 
    fontWeight: 400,
  },

  marginRight: theme.spacing(1), 
}));

export const FolderIconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: '6px', 
  marginBottom: '3px',
  color: primaryColor,
  '& svg': {
    color: theme.palette.custom.lightGrey,
    fontSize: '1.2rem',
  },
}));